import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const SignIn = lazy(() => import('@pages/dashboard/SignIn/index'));

export const SignInRoutes: RouteObject[] = [
  {
    path: '/sign-in',
    element: (
      <React.Suspense>
        <SignIn />
      </React.Suspense>
    ),
  },
];
